import React from 'react'
import { Row, Col, Modal, ListGroup } from 'react-bootstrap'
import ATSearchBox from '../common/formComponent/ATSearchBox'
import { useTranslation } from 'react-i18next'
import { FaPlusCircle } from 'react-icons/fa'
import '../../pages/plants/Plants.css'
import ATIconButton from '../common/formComponent/ATIconButton'
import PlantDetailsForm from './PlantDetailsForm'
import { PlantData } from '../../interface/response/PlantResponse'
import ATLoaderContainer from '../common/loaderContainer/ATLoaderContainer'
import ATModuleMessage from '../common/message/ATModuleMessage'
import PlantListItem from './PlantListItem'
import Authorize from '../common/auth/Authorize'
import { PERMISSIONS, WIDGET_TYPE } from '../common/auth/AuthorizeConstant'
import { getWidgetMapping } from '../../utils/authUtil/AuthUtil'
interface PlantListProps {
  list: PlantData[] | undefined
  selectedPlant: PlantData | undefined
  selectedTab: string
  searchedInputValue: string
  showPlantDetailsFormStatus: boolean
  onSearchQueryHandler: (e: React.SyntheticEvent, selectedTab: string) => void
  updateShowPlantDetailFormStatus: (val: boolean) => void
  handleSelectedItem: (val: string) => void
}

const PlantList: React.FC<PlantListProps> = ({
  list,
  selectedPlant,
  selectedTab,
  searchedInputValue,
  showPlantDetailsFormStatus,
  onSearchQueryHandler,
  updateShowPlantDetailFormStatus,
  handleSelectedItem,
}: PlantListProps) => {
  const { t } = useTranslation(['translation'])
  const renderList = () => {
    if (list?.length === 0) {
      return (
        <ATLoaderContainer>
          <ATModuleMessage />
        </ATLoaderContainer>
      )
    }
    return (
      <ListGroup>
        {list?.map((plant: PlantData) => (
          <PlantListItem
            key={plant?.plantCode}
            plantInfo={plant}
            selectedPlant={selectedPlant?.plantCode ?? ''}
            handleSelectedItem={handleSelectedItem}
          />
        ))}
      </ListGroup>
    )
  }
  return (
    <Row className="plant-list-container h-100 overflow-auto">
      <Col className="h-100" md={12}>
        <div className="search-bar-container d-flex align-items-center justify-content-between">
          <ATSearchBox
            name="plant"
            handleChange={(e) => onSearchQueryHandler(e, selectedTab)}
            onBlurHandler={() => null}
            searchInput={searchedInputValue}
            placeholder={t('plant.search_plants')}
          />
          <div className="px-2">
            <Authorize
              widgetId={getWidgetMapping(PERMISSIONS.ADD_PLANT)}
              widgetType={WIDGET_TYPE.BUTTON}
            >
              <ATIconButton
                variant="primary"
                classes="icon-button"
                icon={<FaPlusCircle size={24} />}
                title={'plant.add'}
                onClick={() => {
                  updateShowPlantDetailFormStatus(true)
                }}
              />
            </Authorize>
          </div>
        </div>
        <div className="scroll-list-content">{renderList()}</div>
      </Col>
      <Modal show={showPlantDetailsFormStatus} className="modal-lg">
        <PlantDetailsForm
          isEdit={false}
          onCloseModal={() => updateShowPlantDetailFormStatus(false)}
        />
      </Modal>
    </Row>
  )
}
export default PlantList
